import { useForecastAppContext } from "@Context/ForecastAppContext/ForecastAppContext";
import { Warning } from "@MeteoApi/models/Warning";
import { WarningService } from "@MeteoApi/services/WarningService";
import { useEffect, useState } from "react";

export const useWarnings = () => {
  const { forecastPointWeek } = useForecastAppContext();
  const [warnings, setWarnings] = useState<Warning[]>([]);
  useEffect(() => {
    const id = forecastPointWeek?.geolocation.alarm_region_id;
    if (id) {
      WarningService.getWarningById({ id })
        .then((response) => {
          setWarnings(response);
          return;
        })
        .catch((e: Error) => {
          // eslint-disable-next-line no-console
          console.error(e);
        });
    }
  }, [forecastPointWeek]);
  return {
    warnings,
    maxPriority: Math.max(
      ...(warnings ?? []).map((w) => w.priority),
    ) as Warning["priority"],
  };
};
